import { useQuery } from 'react-query';

import {
  NEWSLETTER_SUBSCRIPTION_KEY,
  NewsletterSubscriptionStatus,
  getNewsletterSubscriptionStatus,
} from '../utils/backend-api/newsletters';

export default function useCurrentNewsletterSubscription(newsletterId: number) {
  const { data, isFetching, isLoading } = useQuery<NewsletterSubscriptionStatus>(
    [NEWSLETTER_SUBSCRIPTION_KEY, newsletterId.toString()],
    () => getNewsletterSubscriptionStatus({ newsletter_id: newsletterId }),
    {
      refetchInterval: 3000,
      enabled: true,
    }
  );
  return {
    isSubscribed: data?.isSubscribed,
    isCurrentFollowingLoading: isLoading,
    status: isFetching,
  };
}
